import { memo } from 'react';

import { Button, IconButton } from './SendButton.styles';

export interface SendButtonProps {
  title: string;
  onClick: () => void;
  disabled?: boolean;
}

export const SendButton = memo<SendButtonProps>((props) => {
  const { onClick, title, disabled } = props;

  return (
    <Button
      onClick={() => onClick()}
      title={title}
      disabled={disabled}
      role="button"
      aria-label="send button"
      data-testid="SendButton-wrapper"
    >
      <IconButton />
    </Button>
  );
});

SendButton.displayName = 'SendButton';
